/** Text catalogue (CLAUDE.md "Text catalogue"): every visible string comes from shared/text/en/*.json. */

type Entry = { text: string; kind: string }
type Params = Record<string, string | number>

const files = import.meta.glob<Record<string, Entry>>('../../../shared/text/en/*.json', {
  eager: true,
  import: 'default',
})

const bundled: Record<string, string> = {}
for (const file of Object.values(files)) {
  for (const [key, entry] of Object.entries(file)) bundled[key] = entry.text
}

let override: Record<string, string> | null = null

/** Tests only: replace the catalogue (null restores the real one). */
export function setCatalogueForTests(catalogue: Record<string, string> | null): void {
  override = catalogue
}

function lookup(key: string): string | undefined {
  return (override ?? bundled)[key]
}

export function hasText(key: string): boolean {
  return lookup(key) !== undefined
}

export function t(key: string, params?: Params): string {
  const text = lookup(key)
  if (text === undefined) {
    if (import.meta.env.MODE === 'test' || import.meta.env.DEV) throw new Error(`Missing text key: ${key}`)
    return key
  }
  if (!params) return text
  return text.replace(/\{(\w+)\}/g, (match, name: string) => (name in params ? String(params[name]) : match))
}

/** `<key>.one` for 1, `<key>.other` otherwise; `{count}` is filled in. */
export function tCount(key: string, count: number, params?: Params): string {
  return t(`${key}.${count === 1 ? 'one' : 'other'}`, { ...params, count })
}
